import React from "react";
import { MapPin } from "lucide-react";
import { siteData } from "../mock";

export default function Coverage() {
  return (
    <section className="py-20 md:py-28 bg-jk-cream">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-[11px] tracking-[0.32em] text-[#b88b4a] mb-5">TRICITY COVERAGE</div>
        <h2 className="font-serif text-neutral-900 text-[40px] md:text-[60px] leading-[1.05] tracking-tight max-w-4xl">
          We know every sector, <span className="italic">personally.</span>
        </h2>
        <p className="mt-6 text-neutral-700 text-[15.5px] md:text-[17px] leading-[1.8] max-w-3xl">
          Chandigarh, Mohali and Panchkula — three cities, one integrated market. Our team maintains active connections with local authorities, developers and resale networks across every prominent sector.
        </p>

        <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-8">
          {siteData.coverage.map((c) => (
            <div key={c.city} className="bg-white border border-[#e7e2d7] p-8 md:p-10 flex flex-col justify-between min-h-[200px] group hover:border-[#c6a071] transition-colors">
              <MapPin className="w-6 h-6 text-[#b88b4a]" strokeWidth={1.4} />
              <div className="mt-8">
                <div className="font-serif text-neutral-900 text-[32px] md:text-[38px] leading-none">{c.city}</div>
                <div className="mt-4 text-[10.5px] tracking-[0.3em] text-[#b88b4a]">{c.tag}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
